/**
 *
 * @typedef Interview
 * @returns {{get(): Promise, save(payload: Object[]): Promise}}
 */
export const Interview = axios => ({

  /**
   * Store profile interview answers
   * @param slug
   * @param questions
   * @returns Promise<void>
   */
  store(slug, questions) {
    return axios.post(`/v1/profiles/${slug}/interviews`, { questions })
  },

  /**
   * Store profile interview answers
   * @param slug
   * @param payload
   * @returns Promise<void>
   */
  storeProcess(slug, payload) {
    return axios.post(`/v1/profiles/${slug}/interviews/process`, payload)
  },
  /**
   * Get profile interviews
   *
   * @param slug: string
   * @returns Promise
   */
  get(slug) {
    return axios.get(`/v1/profiles/${slug}/interviews/preview`)
  },

  /**
   * Get interview survey with profile answers
   *
   * @param slug: string
   * @param surveyId
   * @returns Promise
   */
  getSurvey(slug, surveyId) {
    return axios.get(`/v1/profiles/${slug}/interviews/survey/${surveyId}`)
  },

  /**
   * Get interview process data
   *
   * @param slug: string
   * @returns Promise
   */
  getProcess(slug) {
    return axios.get(`/v1/profiles/${slug}/interviews/process`)
  },

  finishProcess(slug) {
    const status = 'finished'
    return axios.put(`/v1/profiles/${slug}/interviews/process/status`, { status })
  },

  cancelProcess(slug) {
    const status = 'canceled'
    return axios.put(`/v1/profiles/${slug}/interviews/process/status`, { status })
  }
})
